import React from 'react';
import { useGameStore } from '../store/gameStore';
import { ShieldAlert, Radio, Activity, AlertOctagon } from 'lucide-react';
import clsx from 'clsx';

export const TurnTransitionOverlay: React.FC = () => {
  const turnPhase = useGameStore(state => state.turnPhase);
  const turn = useGameStore(state => state.turn);

  if (turnPhase === 'player') return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/90 backdrop-blur-md animate-fade-in pointer-events-none">
      
      {/* Background Grid Animation */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMGg0MHY0MEgwVjB6bTEgMWgzOHYzOEgxVjF6IiBmaWxsPSJyZ2JhKDIzOSw2OCw2OCwwLjAzKSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+')] opacity-20"></div>

      <div className="flex flex-col items-center gap-8 relative z-10">
        
        {/* Animated Icon */}
        <div className="relative">
          <div className="absolute inset-0 bg-ops-red/20 rounded-full animate-ping" />
          <div className="absolute inset-0 bg-ops-red/10 rounded-full animate-pulse delay-75" />
          <div className="relative bg-slate-900 border-2 border-ops-red p-8 rounded-full shadow-[0_0_60px_rgba(239,68,68,0.4)]">
            <AlertOctagon className="w-16 h-16 text-ops-red animate-pulse" />
          </div>
        </div>

        {/* Text Content */}
        <div className="text-center space-y-3">
          <h2 className="text-5xl font-bold text-white tracking-[0.2em] uppercase animate-slide-up font-mono text-glow-red">
            Enemy Phase
          </h2>
          <div className="flex items-center justify-center gap-3 text-ops-red font-mono text-sm animate-pulse bg-ops-red/10 py-1 px-4 rounded-full border border-ops-red/20">
            <Activity className="w-4 h-4" />
            <span>DETECTING HOSTILE SIGNALS...</span>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="w-96 h-1.5 bg-slate-800 rounded-full overflow-hidden border border-slate-700">
          <div className="h-full bg-ops-red animate-progress-indeterminate shadow-[0_0_10px_rgba(239,68,68,0.8)]" />
        </div>

      </div>
    </div>
  );
};
